export const SEARCH_QUERY_PARAM = 'q';
export const SEARCH_KEY_QUERY_PARAM = 'key';
export const THREAD_ID_QUERY_PARAM = 'threadId';
export const LOADING_SCREEN_CREATIVE_ID = 'loading-state-semantic-inventory-search';
export const SEARCH_ITEMS_LIMIT = 20;
export const FOLLOWUP_CREATIVE_ID = 'edm-entry-follow-up-semantic-search';
export const SURVEY_CREATIVE_ID = 'search-feedback-survey';
export const CSAT_ANSWERS_LIMIT = 50;
export const LAST_TOKEN_CREATIVE_ID = 'edm-entry-last-token';
export const DEALERSHIP_CREATIVE_ID = 'edm-entry-dealership-component';
export const EXTRACT_CREATIVE_ID = 'edm-entry-extractions-component';
